import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { StaticMsgModule } from '@lib/pipes';
import { DutyFreePreorderGuidanceSubHeaderComponent } from './duty-free-preorder-guidance-sub-header.component';

@NgModule({
  declarations: [DutyFreePreorderGuidanceSubHeaderComponent],
  imports: [CommonModule, RouterModule, StaticMsgModule],
  exports: [DutyFreePreorderGuidanceSubHeaderComponent],
})
export class DutyFreePreorderGuidanceSubHeaderModule {}
